import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { DataProvider } from './views/pages/AgentSignin_Link/authentication3/DataContext';
// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';
import React ,{useState,useEffect} from 'react'

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import AlertDialog from 'PendingRequest/PendingRequestDialog';
import  {getReuploadRequest}  from './Axios/Reupload';
import { useLocation } from 'react-router';


// ==============================|| APP ||============================== //

const App = () => {
  // changes
  const customization = useSelector((state) => state.customization);
  // const app_version = '0.1.1';
  const [open, setOpen] = useState(false)
  const[Data,setData]=useState(null)
  const token=sessionStorage.getItem('UserToken')
  const params=useLocation()


  console.log("params",params);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {

    getReuploadRequest(setOpen,setData)
  }, [])

  // useEffect(() => {
  //   const disableContextMenu = (event) => event.preventDefault();
  //   const disableShortcuts = (event) => {
  //     if (
  //       event.ctrlKey &&
  //       ['u', 's', 'c', 'j'].includes(event.key.toLowerCase()) // Ctrl + U, Ctrl + S, Ctrl + Shift + J
  //     ) {
  //       event.preventDefault();
  //     }
  //   };

  //   document.addEventListener('contextmenu', disableContextMenu);
  //   document.addEventListener('keydown', disableShortcuts);

  //   return () => {
  //     document.removeEventListener('contextmenu', disableContextMenu);
  //     document.removeEventListener('keydown', disableShortcuts);
  //   };
  // }, []);
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
        <DataProvider>
          {
            token&&params.pathname!=="/uploadocs"?
            <AlertDialog data={Data} open={open} handleClickOpen={handleClickOpen} handleClose={handleClose}/>
            :
            null
          }
          <Routes />
          </DataProvider>
        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
